import { useCallback } from 'react'

import { Button, Card, CopyToClipboard } from '@circlefin/components'
import { useConnectWallet } from '@shared/wallet/hooks/useConnectWallet'
import useTranslation from 'next-translate/useTranslation'

export const ConnectWalletButton: React.FC = () => {
  const { t } = useTranslation('ace')

  const { address, connect, disconnect, isConnected, isConnecting } =
    useConnectWallet()

  const handleConnect = useCallback(() => {
    void connect()
  }, [connect])

  const handleDisconnect = useCallback(() => {
    disconnect()
  }, [disconnect])

  return isConnected ? (
    <Card
      className="flex items-center justify-between p-4"
      variant="primary/base"
    >
      <CopyToClipboard value={address} variant="inline" />
      <Button onClick={handleDisconnect} size="sm" variant="secondary">
        {t('connectWalletButton.disconnect')}
      </Button>
    </Card>
  ) : (
    <Button
      className="w-full"
      loading={isConnecting}
      onClick={handleConnect}
      variant="primary"
    >
      {t('connectWalletButton.connect')}
    </Button>
  )
}
